(function(){
  // Monte sur <div id="gp-rail-lite-root"></div>
  const mount = document.getElementById('gp-rail-lite-root');
  if(!mount) return;

  /* ===== UI (DOM généré) ===== */
  mount.innerHTML = `
    <div class="g">
      <div class="c">
        <h3 data-i18n="title_top">Top view — draw & dimensions</h3>
        <div class="r">
          <label><span data-i18n="height">Height</span>
            <select id="hSel" class="i"><option>46</option><option>41</option><option>40</option><option>34</option></select>
          </label>
          <label><span data-i18n="finish">Finish</span>
            <select id="fSel" class="i"><option value="Satin" data-i18n="finish_satin">Satin</option><option value="Black" data-i18n="finish_black">Black</option></select>
          </label>
          <label><span data-i18n="lang">Lang</span>
            <select id="lang" class="i"><option value="fr">FR</option><option value="en">EN</option></select>
          </label>
        </div>

        <div class="r">
          <label class="m"><input id="snap90" type="checkbox"> <span data-i18n="snap">Snap 90°</span></label>
          <label class="m"><input id="showD" type="checkbox" checked> <span data-i18n="edit_dims">Edit dims</span></label>
          <button class="b s" id="undo" data-i18n="undo">Undo</button>
          <button class="b s" id="clr" data-i18n="reset">Reset</button>
          <span class="m" id="hint" data-i18n="hint">Click to place points. Each segment pops a bubble to enter inches.</span>
        </div>

        <div id="wrap" style="margin-top:6px">
          <div class="zoombar">
            <button class="zb" id="zTopIn">+</button>
            <button class="zb" id="zTopOut">−</button>
            <button class="zb" id="zTopReset" data-i18n="reset">Reset</button>
          </div>
          <svg id="top" viewBox="0 0 800 220" preserveAspectRatio="xMidYMid meet"></svg>
          <div id="bb" class="bb">
            <form id="bbf" style="display:flex;gap:8px;align-items:center">
              <span class="m" id="lblL" data-i18n="len_in">Length (″)</span>
              <input id="bbn" type="number" min="1" step="0.5">
              <button class="b" type="submit" data-i18n="ok">OK</button>
              <button class="b s" type="button" id="bbx">X</button>
            </form>
          </div>
        </div>

        <div class="r" style="margin-top:6px">
          <label class="m"><input id="wL" type="checkbox"> <span data-i18n="wall_start">Wall at start</span></label>
          <label class="m"><input id="wR" type="checkbox"> <span data-i18n="wall_end">Wall at end</span></label>
          <label class="m"><input id="wmL" type="checkbox"> <span data-i18n="wm_start">Wall-mount (start)</span></label>
          <label class="m"><input id="wmR" type="checkbox"> <span data-i18n="wm_end">Wall-mount (end)</span></label>
        </div>

        <div id="seged"></div>
        <hr style="margin:14px 0">

        <h3 data-i18n="title_front">Front view (panels & door)</h3>
        <div class="r">
          <label><span data-i18n="show_seg">Show segment</span>
            <select id="segPick" class="i"><option value="all" data-i18n="all">All</option></select>
          </label>
          <label><span data-i18n="door_seg">Door seg #</span>
            <input id="dSeg" class="i" type="number" min="1" step="1">
          </label>
          <label><span data-i18n="door_pos">Door pos (in from left)</span>
            <input id="dOff" class="i" type="number" step="0.5">
          </label>
          <label><span data-i18n="door_w">Door width</span>
            <select id="dW" class="i"><option>36</option><option>34</option><option>32</option></select>
          </label>
          <label><span data-i18n="hinges">Hinges</span>
            <select id="dSide" class="i"><option value="left" data-i18n="left">left</option><option value="right" data-i18n="right">right</option></select>
          </label>
          <button class="b s" id="dClr" data-i18n="remove_door">Remove door</button>
        </div>

        <div style="position:relative">
          <div class="zoombar" style="top:-2px">
            <button class="zb" id="zFrontIn">+</button>
            <button class="zb" id="zFrontOut">−</button>
            <button class="zb" id="zFrontReset" data-i18n="reset">Reset</button>
          </div>
          <svg id="front" viewBox="0 0 800 200" preserveAspectRatio="xMidYMid meet"></svg>
        </div>

        <div class="c guide" style="margin-top:12px">
          <h4 data-i18n="guide_title">How to use the planner (measuring tips)</h4>
          <div id="guide"></div>
        </div>

        <div id="accept" style="margin-top:10px;display:flex;align-items:center;gap:8px">
          <input type="checkbox" id="acceptChk">
          <label for="acceptChk" id="acceptLbl" data-i18n="agree_label">I have read and agree to the terms below</label>
        </div>

        <div class="r" style="margin-top:10px">
          <button class="b" id="add" data-i18n="add_all">Add all to cart</button>
          <button class="b s" id="plink" data-i18n="copy_link">Copy project link</button>
          <button class="b s" id="pdf" data-i18n="pdf">Download PDF</button>
          <button class="b" id="calc" data-i18n="compute">Compute</button>
        </div>

        <div class="c" style="margin-top:10px">
          <h4 data-i18n="disc_title">Important notice / Disclaimer</h4>
          <div id="rules" class="m"></div>
        </div>

        <div id="notes" class="m"></div>
        <div id="warn" class="m" style="color:#b45309;margin-top:6px"></div>
      </div>

      <div class="c">
        <h3 data-i18n="title_bom">Materials & Prices (before tax)</h3>
        <div id="bom"></div>
        <div id="tot" style="margin-top:10px;font-weight:700;font-size:16px"></div>
      </div>
    </div>
  `;

  /* ===== i18n ===== */
  const T={
    en:{
      title_top:"Top view — draw & dimensions",
      title_front:"Front view (panels & door)",
      title_bom:"Materials & Prices (before tax)",
      height:"Height", finish:"Finish", finish_satin:"Satin", finish_black:"Black",
      lang:"Lang", snap:"Snap 90°", edit_dims:"Edit dims",
      undo:"Undo", reset:"Reset",
      hint:"Click to place points. Each segment pops a bubble to enter inches.",
      len_in:'Length (″)', ok:"OK",
      wall_start:"Wall at start", wall_end:"Wall at end", wm_start:"Wall-mount (start)", wm_end:"Wall-mount (end)",
      show_seg:"Show segment", all:"All", door_seg:"Door seg #", door_pos:"Door pos (in from left)",
      door_w:"Door width", hinges:"Hinges", left:"left", right:"right", remove_door:"Remove door",
      pdf:"Download PDF", compute:"Compute",
      add_all:"Add all to cart", copy_link:"Copy project link",
      glass_name:"Glass", hinge_name:"Hinge panel 12mm",
      total_bt:"Total (before tax): ",
      msg_draw_first:"Draw first", msg_compute_first:"Compute first",
      msg_added:"Added to cart", msg_add_fail:"Add to cart failed",
      msg_not_feasible:"Not feasible with inventory/gaps.",
      msg_hinge_min:"Error: hinge-ready panels must be at least 24″ wide.",
      pdf_title:"Glass Railing — Plan & Materials",
      pdf_top:"Top View", pdf_front:"Front View", pdf_bom:"Materials & Prices",
      pdf_date:"Date: ",
      guide_title:"How to use the planner (measuring tips)",
      guide_html:`
        <ul>
          <li><b>Draw your run</b>: click on the top view to place points. Enable “Snap 90°” for straight corners.</li>
          <li><b>Enter lengths</b>: each segment shows a bubble to type inches; you can edit lengths in the table too.</li>
          <li><b>Walls</b>: toggle “Wall at start/end” if the glass starts/ends on a wall.</li>
          <li><b>Door</b>: set segment #, position from left, door width, and hinge side.</li>
          <li><b>Compute</b>: we auto-pick stock panel widths and gaps to cover the full run uniformly.</li>
          <li><b>Zoom & pan</b>: mouse wheel to zoom; hold <kbd>Space</kbd> + drag to pan.</li>
        </ul>
      `,
      disc_title:"Important notice / Disclaimer",
      disc_html:`
        <p><b>Usage & measurements:</b> This planner is a helper tool only. Always verify all glass sizes, hardware types and quantities before checkout.</p>
        <p><b>No refunds / exchanges:</b> Custom tempered glass is final sale. No refund or exchange for wrong use or wrong measurements.</p>
        <p><b>Liability:</b> GlassParts is not responsible for misuse, wrong inputs, or any installation issues. You must ensure compliance with local codes and site conditions.</p>
      `,
      agree_label:"I have read and agree to the terms above",
      agree_required:"Please confirm you have read and agree before continuing."
    },
    fr:{
      title_top:"Vue de haut — dessin & dimensions",
      title_front:"Vue de face (panneaux & porte)",
      title_bom:"Matériaux & Prix (avant taxes)",
      height:"Hauteur", finish:"Fini", finish_satin:"Satiné", finish_black:"Noir",
      lang:"Langue", snap:"Aligner 90°", edit_dims:"Éditer dims",
      undo:"Annuler", reset:"Réinitialiser",
      hint:"Clique pour placer des points. Chaque segment ouvre une bulle pour entrer les pouces.",
      len_in:'Longueur (″)', ok:"OK",
      wall_start:"Mur au début", wall_end:"Mur à la fin", wm_start:"Fixation mur (début)", wm_end:"Fixation mur (fin)",
      show_seg:"Afficher segment", all:"Tous", door_seg:"# segment porte", door_pos:"Position porte (po. du bord gauche)",
      door_w:"Largeur porte", hinges:"Charnières", left:"gauche", right:"droite", remove_door:"Retirer la porte",
      pdf:"Télécharger PDF", compute:"Calculer",
      add_all:"Tout ajouter au panier", copy_link:"Copier le lien du projet",
      glass_name:"Verre", hinge_name:"Panneau charnière 12mm",
      total_bt:"Total (avant taxes) : ",
      msg_draw_first:"Commence par dessiner", msg_compute_first:"Calcule d’abord",
      msg_added:"Ajouté au panier", msg_add_fail:"Échec de l’ajout au panier",
      msg_not_feasible:"Non réalisable avec l’inventaire/espacements.",
      msg_hinge_min:"Erreur : les panneaux charnière doivent avoir au moins 24″ de large.",
      pdf_title:"Garde-corps en verre — Plan & Matériel",
      pdf_top:"Vue de haut", pdf_front:"Vue de face", pdf_bom:"Matériaux & Prix",
      pdf_date:"Date : ",
      guide_title:"Comment utiliser le planner (conseils de prise de mesure)",
      guide_html:`
        <ul>
          <li><b>Dessinez la travée</b> : cliquez en vue de haut pour placer des points. Activez « Aligner 90° » pour des coins droits.</li>
          <li><b>Entrez les longueurs</b> : chaque segment ouvre une bulle pour saisir les pouces; modifiable aussi dans le tableau.</li>
          <li><b>Murs</b> : cochez « Mur au début/à la fin » si le verre commence/finit sur un mur.</li>
          <li><b>Porte</b> : indiquez le # de segment, la position depuis la gauche, la largeur et le côté charnières.</li>
          <li><b>Calculer</b> : on choisit automatiquement des largeurs stock + jeux pour couvrir uniformément la travée.</li>
          <li><b>Zoom & pan</b> : molette pour zoomer; maintenez <kbd>Espace</kbd> et glissez pour déplacer.</li>
        </ul>
      `,
      disc_title:"Avis important / Décharge de responsabilité",
      disc_html:`
        <p><b>Usage & mesures :</b> Ce planner est un outil d’aide. Vérifiez toujours toutes les grandeurs de verre, les types et quantités de quincaillerie avant le paiement.</p>
        <p><b>Sans remboursement/échange :</b> Le verre trempé sur mesure est une vente finale. Aucun remboursement ni échange en cas de mauvaise utilisation ou mauvaise prise de mesure.</p>
        <p><b>Responsabilité :</b> GlassParts n’est pas responsable d’un mauvais usage, de données erronées ou de problèmes d’installation. Vous devez respecter les codes locaux et conditions du chantier.</p>
      `,
      agree_label:"J’ai lu et j’accepte les conditions ci-dessus",
      agree_required:"Veuillez confirmer que vous avez lu et accepté avant de continuer."
    }
  };
  let L = 'fr';

  /* ===== Helpers & Refs ===== */
  const $=id=>document.getElementById(id), A=(q,el=document)=>[...el.querySelectorAll(q)];
  function tr(k){return (T[L]&&T[L][k])||T.en[k]||k;}
  function money(c){return (c/100).toLocaleString(L==='en'?'en-CA':'fr-CA',{style:'currency',currency:'CAD'});}
  function applyI18n(){
    A('[data-i18n]').forEach(n=>{ const k=n.getAttribute('data-i18n'); n.textContent = tr(k); });
    // textes HTML riches (guide + disclaimer)
    const guide = $('guide'); if(guide) guide.innerHTML = T[L].guide_html;
    const rules = $('rules'); if(rules) rules.innerHTML = T[L].disc_html;
    // options visibles finish
    A('#fSel option').forEach(o=>{
      const key = o.getAttribute('data-i18n') || (o.value==='Satin'?'finish_satin':'finish_black');
      o.textContent = tr(key);
    });
  }

  const top=$("top"), front=$("front"), wrap=$("wrap");
  const hSel=$("hSel"), fSel=$("fSel"), lang=$("lang");
  const snap90=$("snap90"), showD=$("showD"), undo=$("undo"), clr=$("clr");
  const wL=$("wL"), wR=$("wR"), wmL=$("wmL"), wmR=$("wmR");
  const segPick=$("segPick"), dSeg=$("dSeg"), dOff=$("dOff"), dW=$("dW"), dSide=$("dSide"), dClr=$("dClr");
  const calc=$("calc"), bomBox=$("bom"), tot=$("tot"), warn=$("warn"), add=$("add"), plink=$("plink"), pdfBtn=$("pdf");
  const bb=$("bb"), bbf=$("bbf"), bbn=$("bbn"), bbx=$("bbx");
  const acceptChk = $("acceptChk");

  let P=[], S=[], J=[], ANG=[], door=null, lastPlan=null, prices=null, lastBom=null, H=46;

  /* ===== Gaps & tol ===== */
  const GMIN=.5, GMAX=1.0;
  const ADJ_G_MIN=1.625, ADJ_G_MAX=2.0;
  const WG_MIN=.5, WG_MAX=.625;
  const GH=.25, GL=.625, TOL=3, RANGE=20;
  const OVER_OPACITY=0.55;

  /* Icônes */
  const ICONS={CON180S:{wIn:3.625,hIn:1.1},CON90S:{wIn:2.625,hIn:1.0},CON345S:{wIn:2.375,hIn:1.0},LATCH:{wIn:2.5,hIn:1.0},HINGE:{wIn:2.0,hIn:1.0},SPIGOT:{wIn:2.0,hIn:6.0}};
  const ICON_COL={'180':'#111','90':'#111','adj':'#6b7280','hinge':'#6b7280','latch':'#9ca3af'};

  /* Shopify handles — un seul produit connecteurs (verre-verre) */
  const HND={
    glass:{46:"height-46-1168-4mm-railing-12mm-clear-tempered-glass",41:"12mm-clear-tempered-glass-41x-12-to-72",40:"height-40-1016mm-railing-12mm-clear-tempered-glass",34:"railing-12mm-clear-tempered-glass"},
    hinge:"railing-12mm-clear-tempered-glass-with-hinge-cutout",
    door:"10mm-clear-tempered-glass-door-with-hinge-cutout",
    hingeSet:"spring-self-closing-glass-door-hinge-set",
    spig:"titan-series-8-height-adjustable-spigot-square",
    latch:"pool-fencing-latches-1",
    c:"railing-connectors-180-glass-to-glass"
  };

  async function getP(h){const r=await fetch(`/products/${h}.js`); if(!r.ok) throw 0; return r.json();}
  function pDims(t){t=(t||"").toLowerCase(); const mm=[...t.matchAll(/(\d+(?:\.\d+)?)\s*mm/g)].map(m=>+m[1]); const inc=[...t.matchAll(/(\d+(?:\.\d+)?)\s*(?:["in]|inch|inches)?\b/g)].map(m=>+m[1]); let H=null,W=null; if(mm.length>=2){H=Math.round(mm[0]/25.4);W=Math.round(mm[1]/25.4);} else if(inc.length>=2){H=Math.round(inc[0]);W=Math.round(inc[1]);} else if(mm.length>=1&&inc.length>=1){H=Math.round(mm[0]/25.4);W=Math.round(inc[0]);} else {if(inc.length===1)H=Math.round(inc[0]); if(inc.length>=2){H=Math.round(inc[0]);W=Math.round(inc[1]);}} return {h:H,w:W};}
  function idxStd(prod){const m={}; (prod.variants||[]).forEach(v=>{const d=pDims(v.title); if(d.w!=null) m[d.w]=v;}); Object.keys(m).forEach(k=>{const w=+k; if(w<4||w>84) delete m[k];}); return m;}
  function idxHinge(prod){const R={}; (prod.variants||[]).forEach(v=>{const d=pDims(v.title); if(d.h==null||d.w==null) return; (R[d.h]||(R[d.h]={}))[d.w]=v;}); if(R[46]) Object.keys(R[46]).forEach(k=>{const w=+k; if(w<24||w>72||w%2) delete R[46][k];}); return R;}
  async function loadPrices(h){
    const [g,hg,d,hs,sp,lt,c]=await Promise.all([
      getP(HND.glass[h]), getP(HND.hinge), getP(HND.door), getP(HND.hingeSet),
      getP(HND.spig), getP(HND.latch), getP(HND.c)
    ]);
    return {g,gs:idxStd(g),hg,hi:idxHinge(hg),d,hs,sp,lt,c};
  }

  /* ===== TOP DRAW ===== */
  function svgp(svg,e){const p=svg.createSVGPoint();p.x=e.clientX;p.y=e.clientY;return p.matrixTransform(svg.getScreenCTM().inverse());}
  function angleDeg(a,b,c){const v1={x:a.x-b.x,y:a.y-b.y},v2={x:c.x-b.x,y:c.y-b.y};const dot=v1.x*v2.x+v1.y*v2.y,m1=Math.hypot(v1.x,v1.y),m2=Math.hypot(v2.x,v2.y);const cs=Math.max(-1,Math.min(1,dot/(m1*m2||1)));return +(Math.acos(cs)*180/Math.PI).toFixed(1);}

  function drawTop(){
    while(top.firstChild) top.removeChild(top.firstChild);
    for(let x=20;x<780;x+=20){const l=document.createElementNS("http://www.w3.org/2000/svg","line");l.setAttribute("x1",x);l.setAttribute("y1",0);l.setAttribute("x2",x);l.setAttribute("y2",220);l.setAttribute("stroke","#f3f4f6");top.appendChild(l);}
    for(let y=20;y<220;y+=20){const l=document.createElementNS("http://www.w3.org/2000/svg","line");l.setAttribute("x1",0);l.setAttribute("y1",y);l.setAttribute("x2",800);l.setAttribute("y2",y);l.setAttribute("stroke","#f3f4f6");top.appendChild(l);}

    for(let i=0;i<P.length-1;i++){
      const p1=P[i], p2=P[i+1];
      const ln=document.createElementNS("http://www.w3.org/2000/svg","line");
      ln.setAttribute("x1",p1.x); ln.setAttribute("y1",p1.y);
      ln.setAttribute("x2",p2.x); ln.setAttribute("y2",p2.y);
      ln.setAttribute("stroke","#111"); ln.setAttribute("stroke-width","3"); ln.setAttribute("stroke-linecap","round");
      top.appendChild(ln);

      // étiquette décalée perpendiculaire (évite chevauchement)
      const dx=p2.x-p1.x, dy=p2.y-p1.y, len=Math.hypot(dx,dy)||1;
      const ux=dx/len,  uy=dy/len; const nx=-uy, ny=ux;
      const midx=p1.x+ux*(len*0.5), midy=p1.y+uy*(len*0.5);

      if(showD.checked&&S[i]){
        const off=12;
        const tx=document.createElementNS("http://www.w3.org/2000/svg","text");
        tx.setAttribute("x",midx+nx*off);
        tx.setAttribute("y",midy+ny*off);
        tx.setAttribute("text-anchor","middle");
        tx.setAttribute("font-size","12");
        tx.setAttribute("class","pill");
        tx.textContent=S[i].len+'"';
        top.appendChild(tx);

        const hit=document.createElementNS("http://www.w3.org/2000/svg","rect");
        const w=96,h=26;
        hit.setAttribute("x",midx-w/2+nx*(off-2));
        hit.setAttribute("y",midy-h/2+ny*(off-2));
        hit.setAttribute("width",w); hit.setAttribute("height",h);
        hit.setAttribute("fill-opacity","0"); hit.setAttribute("cursor","text");
        hit.setAttribute("data-seg",String(i));
        top.appendChild(hit);
      }

      if(i<P.length-2){
        const a=ANG[i]??90, is90=(Math.abs(90-a)<=TOL);
        const c=document.createElementNS("http://www.w3.org/2000/svg","circle");
        c.setAttribute("cx",p2.x); c.setAttribute("cy",p2.y); c.setAttribute("r","4");
        c.setAttribute("fill",is90?"#9ca3af":"#ef4444");
        c.setAttribute("title",(is90?"90°":"Adj ")+a+"°");
        top.appendChild(c);
      }
    }
    P.forEach(p=>{const c=document.createElementNS("http://www.w3.org/2000/svg","circle");c.setAttribute("cx",p.x);c.setAttribute("cy",p.y);c.setAttribute("r","4");c.setAttribute("fill","#2563eb");top.appendChild(c);});
  }

  // Ajout points/segments
  top.addEventListener("click",e=>{
    if(e.target&&e.target.getAttribute("data-seg")!=null) return;
    let {x,y}=svgp(top,e);
    if(snap90.checked&&P.length){const q=P[P.length-1],dx=x-q.x,dy=y-q.y; if(Math.abs(dx)>Math.abs(dy)) y=q.y; else x=q.x;}
    if(!P.length){P.push({x,y}); drawTop(); return;}
    const p1=P[P.length-1],p2={x,y},len=+(Math.hypot(p2.x-p1.x,p2.y-p1.y)/4).toFixed(1);
    P.push(p2);
    const i=S.length, isF=(i===0);
    S.push({len, wL:isF&&wL.checked, wR:wR.checked, wmL:isF&&wmL.checked, wmR:wmR.checked});
    if(P.length>=3){const a=angleDeg(P[P.length-3],P[P.length-2],P[P.length-1]); J.push(Math.abs(90-a)<=TOL?"90":"Adj"); ANG.push(a);}
    drawTop(); segEditor(); segDrop();
    const midX=(p1.x+p2.x)/2, midY=(p1.y+p2.y)/2; showBB(i,midX,midY,len);
  });

  function showBB(i,x,y,v){bb.style.display="block"; bbn.value=v; bb.dataset.i=i; const r=wrap.getBoundingClientRect(),m=top.getScreenCTM(),pt=top.createSVGPoint();pt.x=x;pt.y=y;pt=pt.matrixTransform(m); bb.style.left=(pt.x-r.left-70)+"px"; bb.style.top=(pt.y-r.top-44)+"px"; setTimeout(()=>bbn.focus(),0);}
  function hideBB(){bb.style.display="none"; delete bb.dataset.i;}
  bbf.addEventListener("submit",e=>{e.preventDefault(); const i=+bb.dataset.i; const v=parseFloat(bbn.value); if(isNaN(v)||v<=0)return; S[i].len=v; hideBB(); drawTop(); segEditor(); if(lastPlan) calc.click();});
  bbx.onclick=hideBB;
  undo.onclick=()=>{hideBB(); P.pop(); if(S.length)S.pop(); if(J.length)J.pop(); if(ANG.length)ANG.pop(); drawTop(); segEditor(); segDrop(); drawFrontFiltered();}
  clr.onclick=()=>{hideBB(); P=[];S=[];J=[];ANG=[]; drawTop(); segEditor(); segDrop(); drawFrontFiltered();}
  top.addEventListener("click",e=>{
    if(!showD.checked)return;
    const i=e.target&&e.target.getAttribute("data-seg");
    if(i==null)return;
    const a=P[+i],b=P[+i+1]; showBB(+i,(a.x+b.x)/2,(a.y+b.y)/2,S[+i].len);
  });

  /* ===== UI Segments ===== */
  function segEditor(){
    const box=$("seged");
    if(!S.length){box.innerHTML=`<div class="m">${tr('msg_draw_first')}</div>`;return;}
    const rows=S.map((s,i)=>`<tr><td>#${i+1}</td><td><input class="i" data-l="${i}" type="number" min="6" step="0.5" value="${s.len}"></td><td>${i<S.length-1?(J[i]==="90"?"90°":(ANG[i]?.toFixed?.(1)||"Adj")):"-"}</td><td>${i===0?(L==='fr'?'Début':'Start'):(L==='fr'?'Fin':'End')}</td></tr>`).join("");
    box.innerHTML=`<div class="c" style="margin-top:8px"><table class="t"><thead><tr><th>#</th><th>${tr('len_in')}</th><th>${L==='fr'?'Coin':'Corner'}</th><th>${L==='fr'?'Côté':'Side'}</th></tr></thead><tbody>${rows}</tbody></table></div>`;
    A('input[data-l]',box).forEach(x=>x.onchange=()=>{const i=+x.dataset.l; S[i].len=parseFloat(x.value)||S[i].len; drawTop(); if(lastPlan) calc.click();});
  }
  function segDrop(){
    const cur=segPick.value||"all";
    segPick.innerHTML=`<option value="all">${tr('all')}</option>`+S.map((_,i)=>`<option value="${i}">${(L==='fr'?'Segment':'Segment')} #${i+1}</option>`).join("");
    segPick.value=A("option",segPick).some(o=>o.value===cur)?cur:"all";
  }
  segPick.onchange=()=>drawFrontFiltered();
  dClr.onclick=()=>{door=null; drawFrontFiltered();};

  /* ===== Assembling (panels/door) ===== */
  function ensurePanelGaps(parts,g){const isStd=p=>p&&p.type==="panel"; for(let i=0;i<parts.length-1;i++){const A=parts[i],B=parts[i+1]; if(isStd(A)&&isStd(B)){parts.splice(i+1,0,{type:"gap",w:g,role:"panelGap"}); i++;}} return parts;}
  function distributeResidual(parts,target){
    let cur=parts.reduce((a,b)=>a+((b.type?b.w:0)||0),0);
    let left=+(target-cur).toFixed(4);
    const ranges=parts.map(p=>{
      if(p.type!=="gap")return null;
      if(p.role==="panelGap")return{p,min:GMIN,max:GMAX};
      if(p.role==="wallGapL"||p.role==="wallGapR")return{p,min:WG_MIN,max:WG_MAX};
      if(p.role==="adjGap")return{p,min:ADJ_G_MIN,max:ADJ_G_MAX};
      return null;
    }).filter(Boolean);
    for(let pass=0;pass<3 && Math.abs(left)>0.0001 && ranges.length;pass++){
      for(const r of ranges){
        if(Math.abs(left)<=0.0001) break;
        const target = left>0 ? r.max : r.min;
        const delta  = target - (r.p.w||0);
        const step   = Math.max(-Math.abs(left), Math.min(Math.abs(left), delta));
        r.p.w = +((r.p.w||0)+step).toFixed(4);
        left  = +(left - step).toFixed(4);
      }
    }
    return parts;
  }
  function stdAvail(){return Object.keys(prices.gs).map(n=>+n).filter(w=>w>=4&&w<=84).sort((a,b)=>b-a);}
  function hingAvail(){const row=prices.hi[H]||{}; return Object.keys(row).map(n=>+n).sort((a,b)=>a-b);}
  function uniFirst(Li,g,avail){
    let best=null; for(let n=1;n<=7;n++){const target=Li-(n-1)*g; if(target<4)break; for(const w of avail){const left=Li-(n*w+(n-1)*g); if(Math.abs(left)<=0.75+1e-6){const sc=n*1e6+Math.abs(left)*1e4; if(!best||sc<best.sc) best={ps:Array(n).fill(w),g,left,sc,u:1};}} if(best&&best.u)break;}
    if(!best)return null; const out=[]; best.ps.forEach((w,i)=>{out.push({type:"panel",w}); if(i<best.ps.length-1) out.push({type:"gap",w:best.g,role:"panelGap"});}); return out;
  }
  function score(Li,g,ws){const n=ws.length,sum=ws.reduce((a,b)=>a+b,0),left=Li-(sum+(n-1)*g);const min=Math.min(...ws),max=Math.max(...ws),rng=max-min;const mean=sum/n;const v=ws.reduce((a,b)=>a+(b-mean)**2,0)/Math.max(1,(n-1));const pen=rng>RANGE?(rng-RANGE)*1e5:0;return n*1e9+rng*1e6+Math.abs(left)*1e5+v*1e3-min*10+pen;}
  function fillAvail(Li,g,avail){
    const u=uniFirst(Li,g,avail); if(u) return u;
    let best=null; const A2=[...avail].sort((a,b)=>b-a).slice(0,30);
    for(let n=1;n<=7;n++){
      const target=Li-(n-1)*g; if(target<4)break;
      const pick=[];
      function dfs(i,st,rem){
        if(i===n){
          const ws=[...pick],sc=score(Li,g,ws); const left=Li-(ws.reduce((a,b)=>a+b,0)+(n-1)*g);
          if(Math.abs(left)<=0.75+1e-6 && (!best||sc<best.sc)) best={ws,g,left,sc}; return;
        }
        for(let k=st;k<A2.length;k++){
          const w=A2[k],minR=(n-i-1)*Math.min(...A2);
          if(w>rem-minR+1e-6) continue;
          pick.push(w); dfs(i+1,k,rem-w); pick.pop();
        }
      }
      dfs(0,0,target); if(best) break;
    }
    if(!best)return null; const out=[]; best.ws.forEach((w,i)=>{out.push({type:"panel",w}); if(i<best.ws.length-1) out.push({type:"gap",w:best.g,role:"panelGap"});}); return out;
  }
  function pickHingeNearestLE(side,avail){let best=null; for(const w of avail){if(w>side+1e-6) break; const diff=Math.abs(side-w); if(!best||diff<best.diff||(diff===best.diff&&w>best.w)) best={w,diff};} return best?best.w:null;}
  function eliminateTinyTails(parts,g){
    const minW=12, isStd=p=>p&&p.type==="panel";
    function trySide(side){
      if(side==="left"){
        const idx=parts.findIndex(isStd); if(idx<0) return;
        const first=parts[idx]; if(first.w>=minW) return;
        const need=first.w; parts.splice(idx,1);
        if(parts[idx] && parts[idx].type==="gap") parts.splice(idx,1);
        const gapsIdx=parts.map((p,i)=>({p,i})).filter(x=>x.p.type==="gap"&&x.p.role==="panelGap");
        if(gapsIdx.length){const delta=Math.min(GMAX-g, need/gapsIdx.length); gapsIdx.forEach(x=>x.p.w+=delta);} else {const ni=parts.findIndex(isStd); if(ni>=0) parts[ni].w+=need;}
      }else{
        let last=-1; for(let i=parts.length-1;i>=0;i--){const p=parts[i]; if(isStd(p)){last=i;break;}}
        if(last<0) return;
        const tgt=parts[last]; if(tgt.w>=minW) return;
        const need=tgt.w; parts.splice(last,1);
        if(parts[last-1] && parts[last-1].type==="gap") parts.splice(last-1,1);
        const gapsIdx=parts.map((p,i)=>({p,i})).filter(x=>x.p.type==="gap"&&x.p.role==="panelGap");
        if(gapsIdx.length){const delta=Math.min(GMAX-g, need/gapsIdx.length); gapsIdx.forEach(x=>x.p.w+=delta);} else {let li=-1; for(let i=parts.length-1;i>=0;i--){const p=parts[i]; if(isStd(p)){li=i;break;}} if(li>=0) parts[li].w+=need;}
      }
    }
    trySide("left"); trySide("right");
    return parts;
  }
  function compSeg(seg,i,n,g,doorCfg){
    if(i===0){seg.wL=!!wL.checked; seg.wmL=!!wmL.checked;}
    if(i===n-1){seg.wR=!!wR.checked; seg.wmR=!!wmR.checked;}
    const nearAdj = (J[i-1]==="Adj") || (J[i]==="Adj");
    const gUse = nearAdj ? Math.max(g,ADJ_G_MIN) : g;

    const leftGlass= i>0 && !seg.wL, rightGlass= i<n-1 && !seg.wR;
    const dedL= seg.wL?WG_MIN:(leftGlass?GMIN:0), dedR= seg.wR?WG_MIN:(rightGlass?GMIN:0);
    const usable=seg.len - dedL - dedR;

    const STD=stdAvail(), HNG=hingAvail();
    const parts=[];

    if(doorCfg){
      const off=Math.max(0,Math.min(usable,doorCfg.off)), dw=doorCfg.dw, side=doorCfg.side;
      if(side==='left'){
        const leftRoom = off;
        if(leftRoom<24-1e-6) return {ok:false,err:"hingeMin"};
        const wH=pickHingeNearestLE(leftRoom,HNG); if(!wH) return {ok:false,err:"hingeAvail"};
        const leftRem = leftRoom - wH;
        if(seg.wL) parts.push({type:"gap",w:WG_MIN,role:"wallGapL"});
        if(leftRem>=4){ const fill = fillAvail(leftRem, gUse, STD); if(!fill) return {ok:false,err:"std"}; parts.push(...fill); }
        parts.push({type:"hinge",w:wH},{type:"gap",w:GH,role:"doorHinge"},{type:"door",w:dw},{type:"gap",w:GL,role:"doorLatch"});
        const rightRoom = Math.max(0, usable - (off + GH + dw + GL));
        if(rightRoom>=4){ const fillR = fillAvail(rightRoom, gUse, STD); if(!fillR) return {ok:false,err:"std"}; parts.push(...fillR); }
        if(seg.wR) parts.push({type:"gap",w:WG_MIN,role:"wallGapR"});
      }else{
        if(seg.wL) parts.push({type:"gap",w:WG_MIN,role:"wallGapL"});
        if(off>=4){ const fillL = fillAvail(off, gUse, STD); if(!fillL) return {ok:false,err:"std"}; parts.push(...fillL); }
        parts.push({type:"gap",w:GH,role:"doorHinge"},{type:"door",w:dw},{type:"gap",w:GL,role:"doorLatch"});
        const rightRoom = Math.max(0, usable - (off + GH + dw + GL));
        if(rightRoom<24-1e-6) return {ok:false,err:"hingeMin"};
        const wH=pickHingeNearestLE(rightRoom,HNG); if(!wH) return {ok:false,err:"hingeAvail"};
        parts.push({type:"hinge",w:wH});
        const rem = rightRoom - wH;
        if(rem>=4){
          parts.push({type:"gap",w:gUse,role:"panelGap"});
          const fillR = fillAvail(rem - gUse, gUse, STD);
          if(!fillR) return {ok:false,err:"std"}; parts.push(...fillR);
        }
        if(seg.wR) parts.push({type:"gap",w:WG_MIN,role:"wallGapR"});
      }
    }else{
      if(seg.wL) parts.push({type:"gap",w:WG_MIN,role:"wallGapL"});
      const fill = fillAvail(usable, gUse, STD);
      if(!fill && usable>=4) return {ok:false,err:"std"}; if(fill) parts.push(...fill);
      if(seg.wR) parts.push({type:"gap",w:WG_MIN,role:"wallGapR"});
    }

    ensurePanelGaps(parts,gUse);
    eliminateTinyTails(parts,gUse);
    distributeResidual(parts, usable);

    return {ok:true,parts,total:parts.reduce((a,b)=>a+(b.w||0),0), wL:seg.wL,wR:seg.wR, wmL:seg.wmL,wmR:seg.wmR};
  }
  function bindVars(plan){
    return plan.map(seg=>{
      const p=seg.parts.map(pt=>{
        if(pt.type==="panel"){ const v=prices.gs[Math.round(pt.w)]; return {...pt, v:v?{id:v.id,price:v.price,title:v.title}:null}; }
        if(pt.type==="hinge"){ const row=prices.hi[H]||{}, v=row[Math.round(pt.w)]; return {...pt, v:v?{id:v.id,price:v.price,title:v.title}:null}; }
        return pt;
      });
      return {...seg,parts:p};
    });
  }

  /* ===== BOM ===== */
  function pickConnectorVariant(kind, finish){
    const key = finish==="Satin" ? "brushed" : "black";
    const variants = prices.c?.variants || [];
    const byKind = variants.filter(v=>{
      const t=(v.title||"").toLowerCase();
      if(kind==='180') return /180/.test(t) && !/90/.test(t);
      if(kind==='90')  return /90/.test(t);
      if(kind==='adjustable') return /adjustable|réglable|ajustable/.test(t);
      if(kind==='wall') return /wall|mur/.test(t); // Peut ne pas exister : on retombera sur le fallback
      return false;
    });
    let pool = byKind.filter(v=>(v.title||"").toLowerCase().includes(key));
    if(!pool.length) pool = byKind.length?byKind:variants;
    return pool[0]||variants[0]||null;
  }
  function pickByFinish(variants, finish){
    const want = (finish==="Satin") ? ["satin","brushed"] : ["matte","black"];
    const t = v => (v.title||"").toLowerCase();
    let v = (variants||[]).find(v=>want.some(k=>t(v).includes(k)));
    if(!v) v = (variants||[])[0]||null;
    return v;
  }
  function buildBOM(bPlan){
    const bom={lines:[],tot:0,sp:0,c90:0,c180:0,cwm:0,d:0,hset:0,lat:0,adjAngles:[]};
    const isStdPanel=p=>p&&p.type==="panel";
    J.forEach((j,idx)=>{ if(j==="90") bom.c90++; else bom.adjAngles.push(ANG[idx]||90); });

    bPlan.forEach(seg=>{
      for(let i=0;i<seg.parts.length-2;i++){
        const A=seg.parts[i],B=seg.parts[i+1],C=seg.parts[i+2];
        const ok = isStdPanel(A) && B && B.type==="gap" && B.role==="panelGap" && isStdPanel(C);
        if (ok) bom.c180++;
      }
    });

    const map={};
    bPlan.forEach(seg=>{
      seg.parts.forEach(p=>{
        if(p && (p.type==="panel"||p.type==="hinge")){
          const v=p.v;if(!v)return; const id=v.id,name=((p.type==="hinge")?tr('hinge_name'):tr('glass_name'))+` ${H}″ × ${Math.round(p.w)}″`;
          if(!map[id]) map[id]={name,qty:0,u:v.price}; map[id].qty++;
          const w=p.w||0; const n=(w>=4&&w<=12)?1:(w<60?2:3); bom.sp+=n;
        }
        if(p && p.type==="door"){bom.d++; bom.hset++; bom.lat++;}
      });
    });
    Object.entries(map).forEach(([id,l])=>{bom.lines.push({id,name:l.name,qty:l.qty,u:l.u}); bom.tot+=l.u*l.qty;});

    if(bom.d>0){
      const wantW=parseInt(dW.value,10); let best=null;
      (prices.d.variants||[]).forEach(v=>{const d=pDims(v.title); if(d.h===H&&d.w===wantW) best=v;});
      if(!best) best=(prices.d.variants||[]).find(v=>pDims(v.title).w===wantW)||prices.d.variants?.[0];
      if(best){bom.lines.push({id:best.id,name:`Door 10mm ${H}″ × ${wantW}″`,qty:bom.d,u:best.price}); bom.tot+=best.price*bom.d;}
      const finKey=fSel.value==="Satin"?"brushed":"black";
      const hset=(prices.hs.variants||[]).find(v=>(v.title||"").toLowerCase().includes(finKey))||prices.hs.variants?.[0];
      if(hset){bom.lines.push({id:hset.id,name:`Hinge set (${fSel.value==="Satin"?"Brushed SS":"Black"})`,qty:bom.hset,u:hset.price}); bom.tot+=hset.price*bom.hset;}
      const latchVar = pickByFinish(prices.lt.variants||[], fSel.value);
      if(latchVar){bom.lines.push({id:latchVar.id,name:`Pool latch`,qty:bom.lat,u:latchVar.price}); bom.tot+=latchVar.price*bom.lat;}
    }

    const fin=fSel.value==="Satin"?"brushed":"black";
    const sp=(prices.sp.variants||[]).find(v=>(v.title||"").toLowerCase().includes(fin))||prices.sp.variants?.[0];
    if(sp){bom.lines.push({id:sp.id,name:`Titan Spigot (${fSel.value==="Satin"?"Brushed SS":"Black"})`,qty:bom.sp,u:sp.price}); bom.tot+=sp.price*bom.sp;}

    if(bom.c180>0){const v=pickConnectorVariant('180', fSel.value); if(v){bom.lines.push({id:v.id,name:`180° connector (${fSel.value})`,qty:bom.c180,u:v.price}); bom.tot+=v.price*bom.c180;}}
    if(bom.c90>0){const v=pickConnectorVariant('90', fSel.value); if(v){bom.lines.push({id:v.id,name:`90° connector (${fSel.value})`,qty:bom.c90,u:v.price}); bom.tot+=v.price*bom.c90;}}
    if(bom.adjAngles.length){bom.adjAngles.forEach(a=>{const v=pickConnectorVariant('adjustable', fSel.value); if(v){bom.lines.push({id:v.id,name:`Adjustable connector ${Math.round(a)}° (${fSel.value})`,qty:1,u:v.price}); bom.tot+=v.price;}});}
    const wmQty=(wL.checked&&wmL.checked?1:0)+(wR.checked&&wmR.checked?1:0);
    if(wmQty>0){const v=pickConnectorVariant('wall', fSel.value) || pickConnectorVariant('180', fSel.value); if(v){bom.lines.push({id:v.id,name:`Wall-mount (${fSel.value})`,qty:wmQty,u:v.price}); bom.tot+=v.price*wmQty;}}

    return bom;
  }
  function renderBOM(b){
    bomBox.innerHTML=`<table class="t"><thead><tr><th>${L==='fr'?'Article':'Item'}</th><th>Qty</th><th>${L==='fr'?'Unitaire':'Unit'}</th><th>Total</th></tr></thead><tbody>${b.lines.map(l=>`<tr><td>${l.name}</td><td>${l.qty}</td><td>${money(l.u)}</td><td>${money(l.u*l.qty)}</td></tr>`).join('')}</tbody></table>`;
    tot.textContent=tr('total_bt')+money(b.tot)+' CAD';
  }

  /* ===== FRONT VIEW ===== */
  function drawConnectorIcon(xCenter,yTop,sc,vsc,kind='180'){const k= kind==='180'?ICONS.CON180S: kind==='90'?ICONS.CON90S: kind==='adj'?ICONS.CON345S: kind==='hinge'?ICONS.HINGE:ICONS.LATCH; const w=k.wIn*sc,h=k.hIn*vsc; const r=document.createElementNS("http://www.w3.org/2000/svg","rect"); r.setAttribute("x",xCenter-w/2); r.setAttribute("y",yTop-h/2); r.setAttribute("width",w); r.setAttribute("height",h); r.setAttribute("fill",ICON_COL[kind]||'#111'); r.setAttribute("opacity","0.94"); r.setAttribute("rx",Math.min(6,h*0.25)); front.appendChild(r);}
  function drawSpigotIcon(xCenter,baseY,sc,vsc){const w=ICONS.SPIGOT.wIn*sc,h=ICONS.SPIGOT.hIn*vsc; const r=document.createElementNS("http://www.w3.org/2000/svg","rect"); r.setAttribute("x",xCenter-w/2); r.setAttribute("y",baseY-h); r.setAttribute("width",w); r.setAttribute("height",h); r.setAttribute("fill","#4b5563"); r.setAttribute("rx",Math.min(6,h*0.15)); front.appendChild(r);}

  function drawFrontFiltered(){ while(front.firstChild) front.removeChild(front.firstChild); if(!lastPlan) return; const v=segPick.value; if(v==="all") drawFront(lastPlan,0); else {const i=+v; if(lastPlan[i]) drawFront([lastPlan[i]],i);} }
  function drawFront(plan){
    while(front.firstChild) front.removeChild(front.firstChild);
    if(!plan.length) return;
    const pad=18,max=Math.max(...plan.map(p=>p.total||0)), sc=760/Math.max(1,max), ph=120, y=160;
    const vsc=ph/(H||46); const topOffPx=(4/(H||46))*ph; let x=pad;
    let firstX=null,lastX=null;

    plan.forEach(seg=>{
      const sx=x, sw=(seg.total||0)*sc; if(firstX===null) firstX=sx; lastX=sx+sw;
      const baseL=document.createElementNS("http://www.w3.org/2000/svg","line"); baseL.setAttribute("x1",sx); baseL.setAttribute("y1",y); baseL.setAttribute("x2",sx+sw); baseL.setAttribute("y2",y); baseL.setAttribute("stroke","#e5e7eb"); baseL.setAttribute("stroke-width","2"); front.appendChild(baseL);
      let cx=sx;
      (seg.parts||[]).forEach(pt=>{
        const wPx=(pt.w||0)*sc, h=ph;
        if(pt.type==="gap"){ if(pt.role==="panelGap"){const centerX=cx+wPx/2; const iconY=y-ph+topOffPx; drawConnectorIcon(centerX,iconY,sc,vsc,'180');} cx+=wPx; return; }
        const r=document.createElementNS("http://www.w3.org/2000/svg","rect"); r.setAttribute("x",cx); r.setAttribute("y",y-h); r.setAttribute("width",wPx); r.setAttribute("height",h);
        let fill="#e8f0ff", st="#3b82f6"; if(pt.type==="door"){fill="#fff7ed"; st="#b45309";} if(pt.type==="hinge"){fill="#e0f2fe"; st="#0369a1";} r.setAttribute("fill",fill); r.setAttribute("stroke",st); r.setAttribute("rx","6"); front.appendChild(r);
        const tx=document.createElementNS("http://www.w3.org/2000/svg","text"); tx.setAttribute("x",cx+wPx/2); tx.setAttribute("y",y-h-5); tx.setAttribute("text-anchor","middle"); tx.setAttribute("font-size","11"); tx.textContent= pt.type==="door"?(L==='fr'?`Porte ${pt.w}"`:`Door ${pt.w}"`):(pt.type==="hinge"?(L==='fr'?`Charnière ${pt.w}"`:`Hinge ${pt.w}"`):`${Math.round(pt.w)}"`); front.appendChild(tx);
        if(pt.type!=="door"){const pw=pt.w||0; const n=(pw>=4&&pw<=12)?1:(pw<60?2:3); const pos=(n===1)?[pw/2]:(n===2)?[6,pw-6]:[6,pw/2,pw-6]; pos.forEach(pin=>drawSpigotIcon(cx+(pin*sc),y,sc,vsc));}
        else{const side=dSide.value==="left"?"left":"right"; const hingeSeamX=side==="left"?(cx-(GH*sc)/2):(cx+wPx+(GH*sc)/2); const latchSeamX=side==="left"?(cx+wPx+(GL*sc)/2):(cx-(GL*sc)/2); const iconY=y-ph+topOffPx; drawConnectorIcon(hingeSeamX-(0.5*sc),iconY,sc,vsc,'hinge'); drawConnectorIcon(hingeSeamX+(0.5*sc),iconY,sc,vsc,'hinge'); drawConnectorIcon(latchSeamX,iconY,sc,vsc,'latch');}
        cx+=wPx;
      });
      x+=sw+20;
    });
    if(wL.checked && wmL.checked){const iconY= y-ph + (4/(H||46))*ph; drawConnectorIcon(firstX,iconY,760/Math.max(1,Math.max(...plan.map(p=>p.total||0))),ph/(H||46),'90');}
    if(wR.checked && wmR.checked){const iconY= y-ph + (4/(H||46))*ph; drawConnectorIcon(lastX,iconY,760/Math.max(1,Math.max(...plan.map(p=>p.total||0))),ph/(H||46),'90');}
  }

  /* ===== Overlay top (couleurs translucides) ===== */
  function inchesOfPart(pt){if(!pt) return 0; if(pt.type==="panel"||pt.type==="door"||pt.type==="hinge") return pt.w||0; if(pt.type==="gap") return pt.w||0; return 0;}
  function drawTopPlanDisposition(){
    const topSvg=$("top"); if(!topSvg||P.length<2||!Array.isArray(S)) return;
    [...topSvg.querySelectorAll(".ov")].forEach(n=>n.remove());
    for(let i=0;i<S.length;i++){
      const p1=P[i],p2=P[i+1]; if(!p1||!p2) continue;
      const segPlan=(lastPlan && lastPlan[i])?lastPlan[i].parts||[]:[]; const segLen=S[i].len||0;
      const ux=(p2.x-p1.x)/Math.max(1e-6,segLen), uy=(p2.y-p1.y)/Math.max(1e-6,segLen);
      let acc=0;
      const badge=(x,y,text,fill)=>{const g=document.createElementNS("http://www.w3.org/2000/svg","g"); g.setAttribute("class","ov"); const r=document.createElementNS("http://www.w3.org/2000/svg","rect"); const tx=document.createElementNS("http://www.w3.org/2000/svg","text"); r.setAttribute("x",x-18); r.setAttribute("y",y-22); r.setAttribute("rx","6"); r.setAttribute("width","36"); r.setAttribute("height","16"); r.setAttribute("fill",fill); r.setAttribute("opacity","0.85"); tx.setAttribute("x",x); tx.setAttribute("y",y-10); tx.setAttribute("text-anchor","middle"); tx.setAttribute("font-size","10"); tx.setAttribute("fill","#fff"); tx.textContent=text; g.appendChild(r); g.appendChild(tx); topSvg.appendChild(g);};
      badge(p1.x,p1.y,S[i].wL?(L==='fr'?'MUR':'WALL'):(L==='fr'?'LIBRE':'FREE'),S[i].wL?"#6b7280":"#9ca3af");
      badge(p2.x,p2.y,S[i].wR?(L==='fr'?'MUR':'WALL'):(L==='fr'?'LIBRE':'FREE'),S[i].wR?"#6b7280":"#9ca3af");
      const tick=(x,y)=>{const t=document.createElementNS("http://www.w3.org/2000/svg","line"); t.setAttribute("class","ov"); t.setAttribute("x1",x); t.setAttribute("y1",y-5); t.setAttribute("x2",x); t.setAttribute("y2",y+5); t.setAttribute("stroke","#111"); t.setAttribute("stroke-width","2"); t.setAttribute("opacity",".5"); topSvg.appendChild(t);};
      segPlan.forEach(pt=>{const w=inchesOfPart(pt); const xA=p1.x+ux*acc, yA=p1.y+uy*acc; const xB=p1.x+ux*(acc+w), yB=p1.y+uy*(acc+w);
        if(pt.type==="panel"||pt.type==="hinge"||pt.type==="door"){
          const ln=document.createElementNS("http://www.w3.org/2000/svg","line");
          ln.setAttribute("class","ov");
          ln.setAttribute("x1",xA); ln.setAttribute("y1",yA);
          ln.setAttribute("x2",xB); ln.setAttribute("y2",yB);
          ln.setAttribute("stroke",pt.type==="door"?"#b45309":(pt.type==="hinge"?"#0369a1":"#3b82f6"));
          ln.setAttribute("stroke-width","8");
          ln.setAttribute("stroke-linecap","round");
          ln.setAttribute("opacity", String(OVER_OPACITY));
          topSvg.appendChild(ln);
        } else if(pt.type==="gap"){ tick((xA+xB)/2,(yA+yB)/2); }
        acc+=w;
      });
      const label=document.createElementNS("http://www.w3.org/2000/svg","text"); label.setAttribute("class","ov"); label.setAttribute("x",(p1.x+p2.x)/2); label.setAttribute("y",(p1.y+p2.y)/2-10); label.setAttribute("text-anchor","middle"); label.setAttribute("font-size","11"); label.setAttribute("fill","#374151"); label.textContent=(L==='fr'?'Seg #':'Seg #')+(i+1)+((S[i].wL&&S[i].wR)?(L==='fr'?' — mur-à-mur':' — wall-to-wall'):''); label.setAttribute("opacity",".8"); topSvg.appendChild(label);
    }
  }

  /* ===== Zoom & Pan ===== */
  const Z = { top: {init:[0,0,800,220], cur:[0,0,800,220], svg: top}, front:{init:[0,0,800,200], cur:[0,0,800,200], svg: front} };
  function getVB(svg){const vb=(svg.getAttribute('viewBox')||'0 0 800 220').split(/\s+/).map(Number); return vb.length===4?vb:[0,0,800,220];}
  function setVB(which,x,y,w,h){const o=Z[which]; o.cur=[x,y,w,h]; o.svg.setAttribute('viewBox',`${x} ${y} ${w} ${h}`);}
  function resetVB(which){const [x,y,w,h]=Z[which].init; setVB(which,x,y,w,h);}
  let spaceHeld=false, panState=null;
  document.addEventListener('keydown',e=>{ if(e.code==='Space') {spaceHeld=true; e.preventDefault();}});
  document.addEventListener('keyup',e=>{ if(e.code==='Space') {spaceHeld=false; panState=null;} });
  function attachZoom(which){
    const o=Z[which], svg=o.svg;
    svg.addEventListener('wheel',e=>{
      e.preventDefault();
      const [vx,vy,vw,vh]=o.cur; const scale=(e.deltaY<0)?1/1.2:1.2;
      let nw=Math.max(80,Math.min(o.init[2],vw*scale)), nh=Math.max(30,Math.min(o.init[3],vh*scale));
      const pt=svg.createSVGPoint(); pt.x=e.clientX; pt.y=e.clientY; const loc=pt.matrixTransform(svg.getScreenCTM().inverse());
      const cx=(loc.x-vx)/vw, cy=(loc.y-vy)/vh; let nx=loc.x-cx*nw, ny=loc.y-cy*nh;
      nx=Math.max(o.init[0],Math.min(o.init[0]+o.init[2]-nw,nx));
      ny=Math.max(o.init[1],Math.min(o.init[1]+o.init[3]-nh,ny));
      setVB(which,nx,ny,nw,nh);
    },{passive:false});
    svg.addEventListener('mousedown',e=>{ if(!spaceHeld) return; e.preventDefault(); const [vx,vy,vw,vh]=o.cur; panState={which,start:[e.clientX,e.clientY],vb:[vx,vy,vw,vh]};});
    window.addEventListener('mousemove',e=>{ if(!panState) return; const {which:wh,start,vb}=panState, oo=Z[wh]; const dx=(e.clientX-start[0]), dy=(e.clientY-start[1]); const bb=oo.svg.getBoundingClientRect(); const px=dx*(vb[2]/bb.width), py=dy*(vb[3]/bb.height); let nx=Math.max(oo.init[0],Math.min(oo.init[0]+oo.init[2]-vb[2], vb[0]-px)); let ny=Math.max(oo.init[1],Math.min(oo.init[1]+oo.init[3]-vb[3], vb[1]-py)); setVB(wh,nx,ny,vb[2],vb[3]);});
    window.addEventListener('mouseup',()=>{panState=null;});
    const zIn=$('z'+which.charAt(0).toUpperCase()+which.slice(1)+'In');
    const zOut=$('z'+which.charAt(0).toUpperCase()+which.slice(1)+'Out');
    const zReset=$('z'+which.charAt(0).toUpperCase()+which.slice(1)+'Reset');
    function zoomStep(dir){const [vx,vy,vw,vh]=o.cur; const scale=dir>0?1/1.2:1.2; const cx=vx+vw/2, cy=vy+vh/2; let nw=Math.max(80,Math.min(o.init[2],vw*scale)); let nh=Math.max(30,Math.min(o.init[3],vh*scale)); let nx=Math.max(o.init[0],Math.min(o.init[0]+o.init[2]-nw, cx-nw/2)); let ny=Math.max(o.init[1],Math.min(o.init[1]+o.init[3]-nh, cy-nh/2)); setVB(which,nx,ny,nw,nh);}
    if(zIn) zIn.onclick=()=>zoomStep(+1);
    if(zOut) zOut.onclick=()=>zoomStep(-1);
    if(zReset) zReset.onclick=()=>resetVB(which);
  }

  // Patch overlay redraw
  const _orig_drawTop=drawTop; drawTop=function(){_orig_drawTop(); try{if(lastPlan) drawTopPlanDisposition();}catch(e){}};
  const _orig_drawFrontFiltered=drawFrontFiltered; drawFrontFiltered=function(){_orig_drawFrontFiltered(); try{if(lastPlan) drawTopPlanDisposition();}catch(e){}};

  /* ===== Compute ===== */
  const GAP_SCAN=(lo,hi,step=.0625)=>{const out=[]; for(let g=lo;g<=hi+1e-6;g+=step) out.push(+g.toFixed(4)); return out;};
  calc.onclick=async()=>{
    if(!S.length){alert(tr('msg_draw_first'));return;}
    warn.textContent=""; H=parseInt(hSel.value,10); L=lang.value; applyI18n();
    const ds=parseInt(dSeg.value,10), dof=parseFloat(dOff.value), dw=parseInt(dW.value,10), side=dSide.value;
    door=(!isNaN(ds)&&!isNaN(dof)&&!isNaN(dw))?{i:ds-1,off:dof,dw,side}:null;
    prices=await loadPrices(H).catch(()=>null); if(!prices){warn.textContent="Pricing unavailable."; return;}
    if(S.length){ S[0].wL=!!wL.checked; S[0].wmL=!!wmL.checked; S[S.length-1].wR=!!wR.checked; S[S.length-1].wmR=!!wmR.checked; }
    const adjIdx=J.map((j,idx)=> j!=="90" ? idx : -1).filter(i=>i>=0);
    const isSegNearAdj=(i)=> adjIdx.some(k=> i===k || i===k+1);
    const stdCandidates=GAP_SCAN(GMIN,GMAX,0.0625), adjCandidates=GAP_SCAN(ADJ_G_MIN,ADJ_G_MAX,0.0625);
    let best=null, err=null;
    outer: for(const gStd of stdCandidates){ for(const gAdj of adjCandidates){
      const plan=S.map((s,i)=>{ const g=isSegNearAdj(i)?gAdj:gStd; return compSeg({...s},i,S.length,g,(door&&door.i===i)?{off:door.off,dw:door.dw,side:door.side}:null); });
      const bad=plan.find(p=>!p.ok); if(!bad){best=plan; break outer;} err=bad.err;
    }}
    if(!best){ warn.textContent=(err==="hingeMin")?tr('msg_hinge_min'):tr('msg_not_feasible'); lastPlan=null; bomBox.innerHTML=""; tot.textContent=""; drawFrontFiltered(); return; }
    const bnd=bindVars(best); lastPlan=bnd; drawFrontFiltered(); const bom=buildBOM(bnd); lastBom=bom; renderBOM(bom);
  };

  /* ===== Panier + Lien ===== */
  if(add){ add.disabled = true; add.style.opacity = "0.6"; add.style.cursor="not-allowed"; }
  if(acceptChk){
    acceptChk.addEventListener("change", ()=> {
      if(!add) return;
      add.disabled = !acceptChk.checked;
      add.style.opacity = acceptChk.checked ? "1" : "0.6";
      add.style.cursor = acceptChk.checked ? "pointer" : "not-allowed";
    });
  }
  add.onclick=async()=>{
    if(acceptChk && !acceptChk.checked){ alert(tr('agree_required')); return; }
    if(!lastBom||!lastPlan){alert(tr('msg_draw_first'));return;}
    if(warn.textContent.trim()) {alert(tr('msg_not_feasible'));return;}
    const items=lastBom.lines.map(l=>({id:l.id,quantity:l.qty})); if(!items.length){alert(tr('msg_draw_first'));return;}
    try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})}); if(!r.ok) throw 0; await r.json(); alert(tr('msg_added'));}catch{alert(tr('msg_add_fail'));}
  };
  function state(){return {H:parseInt(hSel.value,10),F:fSel.value,P,S,J,ANG,ws:wL.checked,we:wR.checked,wmL:wmL.checked,wmR:wmR.checked,door:door?{...door}:null,sd:showD.checked,sp:snap90.checked,lang:L};}
  plink.onclick=()=>{ try{ const cfg=btoa(unescape(encodeURIComponent(JSON.stringify(state())))); const url=new URL(location.href); url.searchParams.set('cfg',cfg); const final=url.toString(); if(navigator.clipboard && window.isSecureContext){ navigator.clipboard.writeText(final).then(()=>alert(L==='en'?'Link copied':'Lien copié')).catch(()=>{prompt('Copy URL',final);}); } else { prompt('Copy URL',final);} }catch(e){prompt('Copy URL',location.href);} };

  /* ===== PDF ===== */
  pdfBtn.onclick=function(){
    if(!lastPlan){alert(tr('msg_compute_first'));return;}
    const w=window.open('','_blank'); if(!w){alert('Popup blocked');return;}
    const d=w.document; const html=d.documentElement; const head=d.createElement('head'); const body=d.createElement('body');
    const meta=d.createElement('meta'); meta.setAttribute('charset','utf-8'); head.appendChild(meta);
    const title=d.createElement('title'); title.textContent=tr('pdf_title'); head.appendChild(title);
    const style=d.createElement('style');
    style.textContent='body{font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;color:#111;padding:24px}h1{font-size:20px;margin:0 0 8px}.row{display:flex;gap:16px;align-items:flex-start;flex-wrap:wrap}.col{flex:1;min-width:320px}svg{width:100%;height:260px;border:1px solid #e5e7eb;border-radius:8px;background:#fff}table{width:100%;border-collapse:collapse;margin-top:12px;font-size:12px}th,td{border-bottom:1px solid #e5e7eb;padding:6px;text-align:left}.m{color:#6b7280;font-size:12px}';
    head.appendChild(style); html.appendChild(head); html.appendChild(body);

    const h1=d.createElement('h1'); h1.textContent=tr('pdf_title'); body.appendChild(h1);
    const metaLine=d.createElement('div'); metaLine.className='m';
    metaLine.textContent=(L==='en'?'Height: ':'Hauteur : ')+H+'″ • '+(L==='en'?'Finish: ':'Fini : ')+fSel.value+' • '+tr('pdf_date')+ new Date().toLocaleDateString(L==='en'?'en-CA':'fr-CA');
    body.appendChild(metaLine);

    const row=d.createElement('div'); row.className='row'; body.appendChild(row);
    const colL=d.createElement('div'); colL.className='col'; row.appendChild(colL);
    const h2L=d.createElement('h2'); h2L.style.cssText='font-size:16px;margin:12px 0 6px'; h2L.textContent=tr('pdf_top'); colL.appendChild(h2L);
    const phTop=d.createElement('div'); colL.appendChild(phTop);

    const colR=d.createElement('div'); colR.className='col'; row.appendChild(colR);
    const h2R=d.createElement('h2'); h2R.style.cssText='font-size:16px;margin:12px 0 6px'; h2R.textContent=tr('pdf_front'); colR.appendChild(h2R);
    const phFront=d.createElement('div'); colR.appendChild(phFront);

    const h2B=d.createElement('h2'); h2B.style.cssText='font-size:16px;margin:18px 0 6px'; h2B.textContent=tr('pdf_bom'); body.appendChild(h2B);
    const phBOM=d.createElement('div'); body.appendChild(phBOM);
    const phTot=d.createElement('div'); phTot.style.cssText='margin-top:8px;font-weight:700'; body.appendChild(phTot);

    phTop.appendChild(top.cloneNode(true));
    phFront.appendChild(front.cloneNode(true));

    const tbl=d.createElement('table'); const thead=d.createElement('thead'); const trH=d.createElement('tr');
    ['Item','Qty','Unit','Total'].forEach(t=>{const th=d.createElement('th'); th.textContent=t; trH.appendChild(th);});
    thead.appendChild(trH); tbl.appendChild(thead);
    const tbody=d.createElement('tbody');
    (lastBom?.lines||[]).forEach(l=>{const tr=d.createElement('tr');
      const td1=d.createElement('td'); td1.textContent=l.name; tr.appendChild(td1);
      const td2=d.createElement('td'); td2.textContent=l.qty; tr.appendChild(td2);
      const td3=d.createElement('td'); td3.textContent=(l.u/100).toLocaleString(L==='en'?'en-CA':'fr-CA',{style:'currency',currency:'CAD'}); tr.appendChild(td3);
      const td4=d.createElement('td'); td4.textContent=((l.u*l.qty)/100).toLocaleString(L==='en'?'en-CA':'fr-CA',{style:'currency',currency:'CAD'}); tr.appendChild(td4);
      tbody.appendChild(tr);
    });
    tbl.appendChild(tbody); phBOM.appendChild(tbl);
    phTot.textContent=tr('total_bt')+ (lastBom?.tot/100).toLocaleString(L==='en'?'en-CA':'fr-CA',{style:'currency',currency:'CAD'})+' CAD';

    // Note d’acceptation dans le PDF
    const ack=d.createElement('div'); ack.className='m'; ack.style.cssText='margin-top:10px';
    ack.textContent = (acceptChk && acceptChk.checked)
      ? (L==='fr'?'Confirmation : conditions acceptées.':'Confirmation: terms accepted.')
      : (L==='fr'?'Aucune confirmation d’acceptation.':'No acceptance confirmed.');
    body.appendChild(ack);

    w.focus(); w.print();
  };

  /* ===== Langue ===== */
  lang.addEventListener('change',()=>{ L=lang.value; applyI18n(); });

  /* ===== Init ===== */
  (function init(){
    L = (lang && lang.value) || 'fr'; applyI18n();
    // init VB + zoom
    const vbTop=(top.getAttribute('viewBox')||'0 0 800 220').split(/\s+/).map(Number); Z.top.init=(vbTop.length===4?vbTop:[0,0,800,220]); Z.top.cur=[...Z.top.init];
    const vbFront=(front.getAttribute('viewBox')||'0 0 800 200').split(/\s+/).map(Number); Z.front.init=(vbFront.length===4?vbFront:[0,0,800,200]); Z.front.cur=[...Z.front.init];
    attachZoom('top'); attachZoom('front');

    const u=new URL(location.href), cfg=u.searchParams.get('cfg'); drawTop(); segEditor(); segDrop();
    if(!cfg) return; try{
      const o=JSON.parse(decodeURIComponent(escape(atob(cfg))));
      if(o.H) hSel.value=o.H; if(o.F) fSel.value=o.F;
      if(Array.isArray(o.P)) P=o.P; if(Array.isArray(o.S)) S=o.S; if(Array.isArray(o.J)) J=o.J; if(Array.isArray(o.ANG)) ANG=o.ANG;
      if(o.ws) wL.checked=true; if(o.we) wR.checked=true; if(o.wmL) wmL.checked=true; if(o.wmR) wmR.checked=true;
      if(o.sd!==undefined) showD.checked=!!o.sd; if(o.sp!==undefined) snap90.checked=!!o.sp; if(o.lang) {L=o.lang; lang.value=o.lang;}
      if(o.door) {dSeg.value=(o.door.i+1)||""; dOff.value=o.door.off||""; dW.value=o.door.dw||"36"; dSide.value=o.door.side||"left";}
      applyI18n();
    }catch{}
    drawTop(); segEditor(); segDrop(); drawFrontFiltered();
  })();
})();
